var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundOrnament(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 197,
    viewBox: "0 0 40 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-102.063 0.817427C-101.41 0.538313 -100.754 0.265809 -100.095 0H-23.9051C-23.2457 0.265809 -22.5898 0.538313 -21.9373 0.817427H-102.063Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.394 8.9917C-116.969 8.71614 -116.542 8.44365 -116.112 8.17427H-7.88756C-7.45821 8.44365 -7.03099 8.71614 -6.60596 8.9917H-117.394Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-128.328 17.166C-128.008 16.8915 -127.686 16.6191 -127.363 16.3485H3.36267C3.68629 16.6191 4.00821 16.8915 4.3284 17.166H-128.328Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-136.826 25.3403C-136.572 25.0664 -136.317 24.7939 -136.06 24.5228H12.06C12.3168 24.7939 12.572 25.0664 12.8258 25.3403H-136.826Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-143.648 33.5145C-143.443 33.241 -143.237 32.9685 -143.029 32.6971H19.0288C19.2367 32.9685 19.4433 33.241 19.6485 33.5145H-143.648Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-149.186 41.6888C-149.02 41.4155 -148.852 41.143 -148.683 40.8714H24.6828C24.8518 41.143 25.0195 41.4155 25.186 41.6888H-149.186Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-153.667 49.8631C-153.533 49.5899 -153.398 49.3174 -153.262 49.0456H29.2622C29.3984 49.3174 29.5335 49.5899 29.6674 49.8631H-153.667Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.238 58.0373C-157.133 57.7643 -157.027 57.4918 -156.919 57.2199H32.9192C33.0267 57.4918 33.1331 57.7643 33.2384 58.0373H-157.238Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-159.997 66.2116C-159.917 65.9387 -159.837 65.6662 -159.755 65.3942H35.7555C35.837 65.6662 35.9175 65.9387 35.9968 66.2116H-159.997Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-162.01 74.3859C-161.955 74.113 -161.898 73.8405 -161.841 73.5685H37.8407C37.8982 73.8405 37.9545 74.113 38.0099 74.3859H-162.01Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-163.324 82.5602C-163.291 82.2874 -163.258 82.0149 -163.223 81.7427H39.2231C39.2578 82.0149 39.2915 82.2874 39.3241 82.5602H-163.324Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-163.971 90.7344C-163.96 90.4617 -163.949 90.1892 -163.936 89.917H39.9358C39.9486 90.1892 39.9604 90.4617 39.9711 90.7344H-163.971Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-163.971 98.9087C-163.982 98.6365 -163.991 98.364 -164 98.0913H40C39.9914 98.364 39.9818 98.6365 39.9711 98.9087H-163.971Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-163.324 107.083C-163.357 106.811 -163.388 106.538 -163.418 106.266H39.4184C39.388 106.538 39.3566 106.811 39.3241 107.083H-163.324Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-162.01 115.257C-162.065 114.985 -162.119 114.713 -162.172 114.44H38.1721C38.1191 114.713 38.065 114.985 38.0099 115.257H-162.01Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-159.997 123.432C-160.076 123.16 -160.154 122.887 -160.231 122.614H36.2308C36.1539 122.887 36.0759 123.16 35.9968 123.432H-159.997Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.238 131.606C-157.343 131.334 -157.447 131.061 -157.55 130.788H33.5495C33.447 131.061 33.3432 131.334 33.2384 131.606H-157.238Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-153.667 139.78C-153.801 139.508 -153.933 139.236 -154.064 138.963H30.0635C29.9327 139.236 29.8006 139.508 29.6674 139.78H-153.667Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-149.186 147.954C-149.352 147.683 -149.516 147.41 -149.679 147.137H25.6788C25.5158 147.41 25.3515 147.683 25.186 147.954H-149.186Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-143.648 156.129C-143.852 155.857 -144.054 155.585 -144.255 155.311H20.2554C20.0544 155.585 19.8521 155.857 19.6485 156.129H-143.648Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-136.826 164.303C-137.077 164.032 -137.327 163.759 -137.575 163.485H13.5752C13.3269 163.759 13.0771 164.032 12.8258 164.303H-136.826Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-128.328 172.477C-128.644 172.207 -128.958 171.934 -129.27 171.66H5.27049C4.95813 171.934 4.6441 172.207 4.3284 172.477H-128.328Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.394 180.651C-117.81 180.382 -118.223 180.109 -118.635 179.834H-5.36501C-5.77655 180.109 -6.19022 180.382 -6.60596 180.651H-117.394Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M-102.063 188.826C-102.686 188.559 -103.305 188.287 -103.922 188.008H-20.0782C-20.6947 188.287 -21.3144 188.559 -21.9373 188.826H-102.063Z",
    fill: "white",
    fillOpacity: 0.13
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M-49.03 196.183C-53.2774 196.722 -57.6063 197 -62 197C-66.3937 197 -70.7226 196.722 -74.97 196.183H-49.03Z",
    fill: "white",
    fillOpacity: 0.13
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundOrnament);
export default __webpack_public_path__ + "static/media/background-ornament.d37bac815a99f3f55f5cc15ddb904f35.svg";
export { ForwardRef as ReactComponent };